<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_EVENTS"
    title="Events"
    sub-title="Manage your events"
    :breadcrumbs="breadcrumbs"
    page-name="Events"
    align="center"
    width="full"
    action-button-text="Add Event"
    @click:action="openEventModal"
  >
    <SmartFeed
      :pinia-store="useEventFeedStore"
      default-entity-layout="tableRow"
      default-smart-feed-layout="table"
    >
      <template #empty-state>
        <iRow vertical-align="middle">
          <iIcon icon="calender" size="large" />
          <iText>No events yet.</iText>
        </iRow>
      </template>
    </SmartFeed>

    <CreateUpdateEventModal />
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { mapActions, mapState } from "pinia";
import {
  PAGE_PUBLICATION_EVENTS,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed";
import { useEventFeedStore } from "SmartFeed/stores/feed/event-feed-store";
import { useEventStore } from "%/stores/event-store";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import CreateUpdateEventModal from "@/components/publication/CreateUpdateEventModal.vue";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationEvents",
  components: { CreateUpdateEventModal, SmartFeed, PageWrapper },
  data() {
    return {
      PAGE_PUBLICATION_EVENTS,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
      "publicationId",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/${this.publicationId}`,
          label: "Overview",
        },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
  methods: {
    ...mapActions(useEventStore, ["openCreateEventModal"]),
    useEventFeedStore,
    openEventModal() {
      this.openCreateEventModal();
    },
  },
};
</script>
